<template>
  <div class="admin-container">
    <h1>Admin Dashboard</h1>
    
    <div class="tabs">
      <button 
        :class="['tab-button', { active: activeTab === 'users' }]" 
        @click="activeTab = 'users'"
      >
        User Management
      </button>
      <button 
        :class="['tab-button', { active: activeTab === 'groups' }]" 
        @click="activeTab = 'groups'"
      >
        Group Management
      </button>
    </div>
    
    <div class="admin-section">
      <UserManagement v-if="activeTab === 'users'" />
      <GroupManagement v-if="activeTab === 'groups'" />
    </div>
  </div>
</template>

<script>
import UserManagement from '../components/admin/UserManagement.vue'
import GroupManagement from '../components/admin/GroupManagement.vue'

export default {
  name: 'AdminView',
  components: {
    UserManagement,
    GroupManagement
  },
  data() {
    return {
      activeTab: 'users'
    }
  }
}
</script>

<style scoped>
.admin-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.admin-section {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1 {
  margin-bottom: 1.5rem;
  color: var(--primary);
}

.tabs {
  display: flex;
  margin-bottom: 1rem;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.tab-button:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.tab-button:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.tab-button.active {
  background-color: var(--primary);
  color: white;
  border-color: var(--primary);
}

.tab-button:hover:not(.active) {
  background-color: #e6e6e6;
}
</style> 